<div class="additional-full-lot-number-wrapper">
    <ng-container *ngTemplateOutlet="addAdditionalButtons;
    context: {showButtons: !this.state?.additionalFullLotNumbers?.length}"></ng-container>
  <app-pnc-additional-lot-number
    class="additional-full-lot-number"
    (newLotNumberChange)="newLotNumberChange($event)"
    [isDetailMode]="isDetailMode"
    [isInViewMode]="isViewMode"
    [isSolvedStatus]="isSolvedStatus"
    [isSolutionAccepted]="isSolutionAccepted"
    [fullLotNumber]="$safeNavigationMigration(this.state?.fullLotNumber?.fullLotNumber)"
    [fullLotNumberValidators]="fullLotNumberValidators"
    [fullLotNumberId]="$safeNavigationMigration(this.state?.fullLotNumber?.id)"
    [quantity]="$safeNavigationMigration(this.state?.fullLotNumber?.quantity)"
    [quantityValidators]="quantityValidators">
  </app-pnc-additional-lot-number>
</div>
@for (addFullLotNumber of this.state?.additionalFullLotNumbers; track trackByItem(index, addFullLotNumber); let index = $index) {
  <div class="additional-full-lot-number-wrapper">
        <ng-container *ngTemplateOutlet="addAdditionalButtons;
                context: {showButtons: this.state?.additionalFullLotNumbers?.length === index + 1}"></ng-container>
    <app-pnc-additional-lot-number
      class="additional-full-lot-number"
      (deleteClick)="removeAdditionalLotNumbers(addFullLotNumber)"
      (newLotNumberChange)="additionalLotNumberChange($event)"
      [additionalIndex]="index + 1"
      [isDetailMode]="isDetailMode"
      [isInViewMode]="isViewMode"
      [isSolvedStatus]="isSolvedStatus"
      [isSolutionAccepted]="isSolutionAccepted"
      [fullLotNumber]="addFullLotNumber.fullLotNumber"
      [fullLotNumberValidators]="fullLotNumberValidators"
      [fullLotNumberId]="addFullLotNumber.id"
      [quantity]="addFullLotNumber.quantity"
      [quantityValidators]="quantityValidators">
    </app-pnc-additional-lot-number>
  </div>
}

<ng-template #addAdditionalButtons
  let-showButtons="showButtons">
  @if (!this.isViewMode && showButtons) {
    <div class="add-additional-buttons-wrapper">
      <app-pnc-add-addition-input-button (addAdditionalInput)="addAdditionalSeveralFullLotNumber()"
        [disabled]="!canAddSeveral"
        [tooltipMessage]="addSeveralTooltipMessage"
        baseDataCy="pnc-several-full-lot-number"
      label="Add several Full LOT No."></app-pnc-add-addition-input-button>
      <app-pnc-add-addition-input-button (addAdditionalInput)="addAdditionalLotNumber()"
        [disabled]="!canAddAdditional"
        [tooltipMessage]="addAdditionalTooltipMessage"
        baseDataCy="pnc-additional-full-lot-number"
      label="Add additional Full LOT No."></app-pnc-add-addition-input-button>
    </div>
  }
</ng-template>

